'use client';

import { ARTICLE_INDEX_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { withFragment } from '@liquorice/gql-utils';
import PageHeaderRoot from './PageHeaderRoot';
import PageTitle from './PageTitle';

const PageHeaderArticleIndex = withFragment(ARTICLE_INDEX_CARD_FRAGMENT, (data) => {
  if (!data) return null;

  return (
    <PageHeaderRoot variant="index" colorSet="velvet" paper>
      <PageTitle cx={{ textAlign: 'center' }}>{data.entryTitle}</PageTitle>
    </PageHeaderRoot>
  );
});

export default PageHeaderArticleIndex;
